import * as React from 'react';
import { Switch } from '../../../../Dreams/DreamTools/Switch/Switch';
import { HandleValueChange } from '../HandleValueChange';
import * as styles from './GEPSwitch.css';
import { IGEPSwitchOptions } from './IGEPSwitchOptions';

export const GEPSwitch = (props: IGEPSwitchOptions) => (
	<Switch
		label={props.label}
		onChange={(value) => HandleValueChange(props.GEP, value, props.targetProperty)}
		isChecked={props.GEP.state.currentState[props.targetProperty]}
		withClasses={styles.toggle}
	/>
);
